import notificationLauncher from './launcher/notification.launcher';
import notificationWeb from './web/notification.web';
import notificationMock from './mock/notification.mock';
import {resolveBridgeType, BridgeType, ResponseType} from './BridgeApi';
import NotificationType from '../constants/NotificationType';

export interface Notification {
    notificationtype: NotificationType;
}

export type NotificationResponseCallback = (
    notification: Notification,
    responseType: ResponseType
) => void;

export interface NotificationBridge {
    registerResponseCallback(callback: NotificationResponseCallback): Promise<void>;
}

const bridges = {
    [BridgeType.LAUNCHER]: notificationLauncher,
    [BridgeType.WEB]: notificationWeb,
    [BridgeType.MOCK]: notificationMock
};

export default (): NotificationBridge => bridges[resolveBridgeType()];
